export default {
  tight: "0.5rem",
  medium: "1rem",
  loose: "2rem",
};
